import PropTypes from "prop-types";

const Characteristic = ({ inputId, label, characteristic, inputValue, onChange, onRoll }) => {
  const dice = Number(characteristic.diceValue);
  const modifier = Math.floor((dice - 10) / 2);
  const formattedModifier = modifier > 0 ? `+${modifier}` : modifier;
  const roll = () => onRoll(label, modifier);

  return (
    <div
      className="characteristic"
      onClick={(event) => {
        if (event.target.tagName !== "INPUT") roll();
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          roll();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <label htmlFor={inputId} onClick={(event) => event.stopPropagation()}>{label}</label>
      <div className="modifier">{formattedModifier}</div>
      <input
        id={inputId}
        value={inputValue ?? dice}
        type="number"
        className="dice-value"
        min="1"
        max="30"
        onClick={(event) => event.stopPropagation()}
        onChange={(event) => onChange(Number(event.target.value))}
      />
    </div>
  );
};

Characteristic.propTypes = {
  inputId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default Characteristic;
